import { createRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { ForgotPasswordForm } from "@/components/auth/ForgotPasswordForm";
import { rootRoute } from "./rootRoute";

export const forgotPasswordRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/forgot-password",
    component: () => (
        <AuthLayout>
            <ForgotPasswordForm />
        </AuthLayout>
    ),
});
